import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import AddressForm from './cart/AddressForm';
import { ArrowLeft } from 'lucide-react';

const AddressStep = ({
  address,
  setAddress,
  savedAddress,
  selectedAddress,
  setSelectedAddress,
  countries,
  cartItems,
  totalPrice,
  setStep,
  step
}) => {
  const [showContinue, setShowContinue] = useState(false);

  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const toggleContinueButton = () => {
    setShowContinue((prev) => !prev);
  };

  useEffect(() => {
    const validateAddress = () => {
      const currentAddress = selectedAddress === 'saved' && savedAddress ? savedAddress : address;
      const requiredFields = ['fullName', 'phone', 'house', 'number', 'street', 'district', 'city', 'state', 'postalCode', 'country'];
      const isValid = requiredFields.every((field) => currentAddress[field]?.trim());
      setShowContinue(isValid);
    };
    validateAddress();
  }, [address, savedAddress, selectedAddress]);

  return (
    <motion.div variants={containerVariants} initial="hidden" animate="visible">
      <AddressForm
        address={address}
        setAddress={setAddress}
        savedAddress={savedAddress}
        selectedAddress={selectedAddress}
        setSelectedAddress={setSelectedAddress}
        countries={countries}
        cart={cartItems}
        total={totalPrice}
        theme="dark"
        toggleContinueButton={toggleContinueButton}
        setIsContinueDisabled={() => {}} // No longer needed
      />
      <div className="flex justify-between mt-8">
        <motion.button
          onClick={() => setStep(1)}
          className="px-6 py-3 border border-[#DBAE6E] text-[#DBAE6E] rounded-lg text-lg font-medium hover:bg-[#DBAE6E] hover:text-black transition-colors"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <ArrowLeft size={22} className="inline mr-2" /> Back
        </motion.button>
        {showContinue && (
          <motion.button
            onClick={() => setStep(3)}
            className="px-8 py-4 bg-[#DBAE6E] text-black rounded-lg text-lg font-semibold transition-colors hover:bg-[#C89D5D]"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Continue
          </motion.button>
        )}
      </div>
    </motion.div>
  );
};

export default AddressStep;
